<div class="bubble-outer-container referenced-bubble">
  <ng-content></ng-content>
  <span class="invisible" *ngFor="let bubble of bubbles">
    <div
      class="bubble-container {{ bubble?.is_resolved ? 'invisible' : '' }}"
      (click)="triggerOverlayPanel($event, bubble)"
      [id]="'bubble_' + bubble?.id"
      [attr.data-bubble-ref]="bubble?.reference_id"
      [ngStyle]="{
        'left.px': bubble.position.x,
        'top.px': bubble.position.y,
        position: scrollContainer?.tagName?.toLowerCase() === 'body' ? 'absolute' : '',
      }"
      #bubbleContainer>
      {{ bubble?.label }}
    </div>
  </span>
</div>

<p-overlayPanel #op>
  <ng-template pTemplate="content">
    <span (ClickOutsideElement)="overlayPanelOutsideClicked($event)">
      <div class="comments-container">
        <ng-container *ngFor="let comment of active_bubble_post?.comments; let firstComment = first">
          <div class="comment-container" [id]="'bubble_comment_' + comment?.id">
            <div class="comment-info line-as">
              <span class="d-flex align-items-center">
                <ng-container *ngIf="comment?.logo; else avatarLogo">
                  <img [src]="comment.logo" class="rounded-circle" width="23" height="23" />
                </ng-container>
                <ng-template #avatarLogo>
                  <div class="user_thumb">{{ comment?.commented_by?.charAt(0) }}</div>
                </ng-template>
                <label class="f-10 ml-1">
                  <span>{{ comment?.commented_by }}</span>
                  <span class="f-8 time-ago d-block">
                    {{ getMomentDateTime(comment.created_at) | customTimeAgo }}
                  </span>
                </label>
              </span>
              <span class="d-flex align-items-center">
                <div class="hover-card-visible">
                  <img
                    [src]="common_images?.pencil_icon"
                    (click)="onEditComment(comment)"
                    alt=""
                    class="cursor-pointer mr-1"
                    width="22"
                    *ngIf="readWritePermissions?.can_write" />
                  <img
                    [src]="common_images?.delete_icon"
                    (click)="confirmRemoveComment(comment)"
                    alt=""
                    class="cursor-pointer mr-1"
                    width="19"
                    *ngIf="readWritePermissions?.can_delete" />
                </div>
                <img
                  [src]="images?.tick_icon"
                  alt=""
                  *ngIf="firstComment && readWritePermissions?.can_resolve"
                  (click)="onChangeCommentStatus(comment)"
                  class="cursor-pointer {{
                    active_bubble_post?.is_resolved && active_bubble_post?.is_resolved_by_admin
                      ? 'active-approved'
                      : active_bubble_post?.is_resolved && !active_bubble_post?.is_resolved_by_admin === false
                        ? 'active-approved-non-admin'
                        : ''
                  }}" />
              </span>
            </div>
            <hr class="border-breaker" />
            <div class="comment-message mb-1">
              <p [innerHTML]="comment?.message"></p>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="_paragraph custom-template w-212">
        <ckeditor [(ngModel)]="message" placeholder="Type something..." [editor]="Editor"></ckeditor>
        <i class="pi pi-send cursor-pointer" (click)="createComment('', 'add')"></i>
      </div>
    </span>
  </ng-template>
</p-overlayPanel>
